import React from 'react'
import {
    Alert, Row, Col,
    Button, Form, FormGroup, Label, Input,
} from 'reactstrap'
import { Icon } from 'react-icons-kit'
import { ic_phone } from 'react-icons-kit/md/ic_phone'
import { instagram } from 'react-icons-kit/fa/instagram'
import { facebookSquare } from 'react-icons-kit/fa/facebookSquare'
import { linkedinSquare } from 'react-icons-kit/fa/linkedinSquare'
import { twitterSquare } from 'react-icons-kit/fa/twitterSquare'
import { envelope } from 'react-icons-kit/fa/envelope'


export default function formEmpresa(props) {

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Form onSubmit={props.onSubmit}>
                        {
                            props.error &&
                            <FormGroup row>
                                <Col>
                                    <Alert color="danger">
                                        {props.error.message}
                                    </Alert>
                                </Col>
                            </FormGroup>
                        }
                        <FormGroup row>
                            <Label for="Telefono" xs={1}>
                                <Icon size={30} icon={ic_phone} />
                            </Label>
                            <Col xs={11}>
                                <Input onChange={props.onChange} value={props.infoEmpresa.Telefono} type="number" name="Telefono" id="Telefono" placeholder="Teléfono" required />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="Correo" xs={1}>
                                <Icon size={30} icon={envelope} />
                            </Label>
                            <Col xs={11}>
                                <Input onChange={props.onChange} value={props.infoEmpresa.Correo} type="email" name="Correo" id="Correo" placeholder="nombre@dominio.com" required />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="Facebook" xs={1}>
                                <Icon size={32} icon={facebookSquare} />
                            </Label>
                            <Col xs={11}>
                                <Input onChange={props.onChange} value={props.infoEmpresa.Facebook} name="Facebook" id="Facebook" placeholder="Facebook url" type="text" />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="Instagram" xs={1}>
                                <Icon size={32} icon={instagram} />
                            </Label>
                            <Col xs={11}>
                                <Input onChange={props.onChange} value={props.infoEmpresa.Instagram} name="Instagram" id="Instagram" placeholder="Instagram url" type="text" />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="Linkedin" xs={1}>
                                <Icon size={32} icon={linkedinSquare} />
                            </Label>
                            <Col xs={11}>
                                <Input onChange={props.onChange} value={props.infoEmpresa.Linkedin} type="text" name="Linkedin" id="Linkedin" placeholder="Linkedin url" />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="Twitter" xs={1}>
                                <Icon size={32} icon={twitterSquare} />
                            </Label>
                            <Col xs={11}>
                                <Input onChange={props.onChange} value={props.infoEmpresa.Twitter} type="text" name="Twitter" id="Twitter" placeholder="Twitter url" />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Col>
                                <Button className="btn-rojo float-right" disabled={props.guardando}>Guardar</Button>
                            </Col>
                        </FormGroup>

                    </Form>
                </Col>
            </Row>
        </React.Fragment>
    )
}